import axios from "axios";

const API_ROOT = window.__BACKEND_URL__ + "/api/";

const GET_CLIENT_IP = API_ROOT + "client_ip/";

export const getClientIp = async (data) => {
  return await axios.post(GET_CLIENT_IP, {
    ...data,
  });
};
